import React, { useEffect, useState } from "react";
import { FormText, Modal, ModalBody, ModalHeader, Button, ModalFooter } from "reactstrap";
import { Trans } from "react-i18next";
import { handleFileChange } from "services/util";
import {
  useFieldArray,
} from "react-hook-form";
import { formatDateName } from 'services/util';

export const InputFilesForm = ({name, setValue, control, onFilesCountUpdate, uploadedFilesCount, auditor_permission }) => {

  const [previewFile, setPreviewFile] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
  const toggleModal = () => {
    if (modalOpen && previewFile?.startsWith("blob:")) {
      URL.revokeObjectURL(previewFile);
    }
    setModalOpen(!modalOpen);
  };

  const toggleAttachmentModal = () => {
    setAttachmentModalOpen(!attachmentModalOpen);
  };
  const { fields, append, remove } = useFieldArray({
    control,
    name: name,
    keyName: "key",
  });

  useEffect(() => {
    if (!fields || (Array.isArray(fields) && fields.length === 0)) {
      setPreviewFile(null);
      return;
    };
  }, [fields]);


  const onPreviewFile = async (file) => {
    let to_preview = null
    if (!file) {
      return null;
    }

    if (file?.name) {
      // Handle file as base64
      to_preview = file.upload_file
    } else{
      // Handle file as string
      to_preview = await urlToBase64(`/api${file.upload_file}`)
    };

    if (to_preview?.includes("application/pdf") || to_preview?.includes("image/")) {
      if (to_preview.includes("application/pdf")) {
        // Convert base64 PDF to Blob URL to avoid CSP issues
        const byteString = atob(to_preview.split(',')[1]);
        const mimeString = to_preview.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeString });
        const blobUrl = URL.createObjectURL(blob);
  
        setPreviewFile(blobUrl);
        toggleModal();
      } else {
        // Directly set for images
        setPreviewFile(to_preview);
        toggleModal();
      }
    } else {
      handleBase64FileDownload(file);
    }
  };

  async function urlToBase64(fileUrl) {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      };

      const blob = await response.blob();
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting file to Base64:", error);
      throw error;
    }
  }

  function getName(file_obj) {
    if (!file_obj) {
      return;
  }
    
    if (file_obj?.upload_file?.startsWith('data') && file_obj?.name) {
      return file_obj.name;
    }
    else {
      const str_file_path = file_obj.upload_file || file_obj.file;
      if (str_file_path && (typeof (str_file_path) == "string") && str_file_path.includes(".") && file_obj?.id !== undefined) {
        const path_array = str_file_path.split('/')
        const content = path_array[path_array.length - 1]
        return content
      }
    };
    return null;
  };

  const handleBase64FileDownload = (file_obj) => {
    const link = document.createElement("a");
    link.href = `${file_obj.upload_file}`;
    link.download = getName(file_obj);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileRemove = (index) => {
    remove(index);
  };

  const saveUploadedFiles = () => {
    if (attachmentModalOpen) {
      onFilesCountUpdate(fields?.length);
      toggleAttachmentModal();
    }
  };
  
  const onClose = () => {
    toggleAttachmentModal();
  };
  console.log(auditor_permission, "??? auditor_permission");
  
  return (
    <>
      <div>
        <div className="input-group input-group-lg">
          <div className="custom-file text-center align-middle justify-content-center d-flex align-items-center">
            <Button className="" color="primary" onClick={toggleAttachmentModal}>
                {
                  fields[0]?.upload_file?.startsWith("/media/") > 0 ?  `Attachments - ${fields?.length}` : uploadedFilesCount ? `Attachments - ${uploadedFilesCount}` : "Attach"
                }
            </Button>
          </div>
        </div>

        {/* files Preview Modal */}
        <Modal isOpen={modalOpen} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <Trans>File Preview</Trans>
          </ModalHeader>
          <ModalBody>
            {previewFile && (
              <>
                {previewFile?.startsWith("blob") && (
                  <embed src={previewFile} width="100%" height="500px" type="application/pdf" />
                )}
                {previewFile?.startsWith("data:image") && (
                  <img src={previewFile} alt="Preview" style={{ width: "100%", height: "auto" }} />
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal}>
              <Trans>Close</Trans>
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal for displaying the selected files */}
        <Modal size="md" isOpen={attachmentModalOpen} toggle={toggleAttachmentModal}>
          <ModalHeader toggle={toggleAttachmentModal}>
            <Trans>Related Files</Trans>
          </ModalHeader>
          <ModalBody>
              {fields?.length > 0 && (
            <div className="files-list w-100">
              {fields.map((file, index) => {
                return (
                  <>
                    <div className="container" key={index}>
                      <div className="row d-flex justify-content-between align-items-center">
                        <div className="col-auto">
                          <a
                            onClick={() => onPreviewFile(file)}
                            className="file-name text-truncate text-success clickable"
                            style={{ maxWidth: "200px"}}
                          >
                            {(file?.name || getName(file)).length > 30
                              ? (file?.name || getName(file)).substring(0, 20) + '...'
                              : (file?.name || getName(file))
                            }
                          </a>
                        </div>
                        <div>
                          {file?.created_at ? formatDateName(file?.created_at) : ""}
                        </div>
                        <div className="col-auto">
                          {auditor_permission === false && (
                            <button
                            className="bg-white border-0 text-danger"
                            onClick={() => handleFileRemove(index)} 
                            aria-label="Remove file"
                          >
                            <i className="fa fa-times-circle clickable"></i>
                          </button>
                          )}
                        </div>

                      </div>
                    </div>
                    <hr/>
                  </>
                )
              })}
              
              
            </div>
            )}
              {auditor_permission === false && (
                <>
                <label htmlFor="uploadFileInput" className="btn btn-primary mb-3">
                <Trans>Upload Files</Trans>
              </label>
              <input
                type="file"
                id="uploadFileInput"
                className="d-none"
                multiple
                onChange={(e) => handleFileChange(e, fields, setValue, append)}
              />
              </>
              )}
          </ModalBody>
          <ModalFooter className="justify-content-between">
            <Button color="secondary" onClick={() => onClose()}>
              <Trans>Close</Trans>
            </Button>
            {auditor_permission === false && (
              <label className="btn btn-primary mb-3" onClick={saveUploadedFiles}>
              <Trans>Save</Trans>
            </label>
            )}
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default InputFilesForm;
